import style from "./template-card.module.css";
import { getPathPrefix } from "utils/getPathPrefix";
import { ContextMenuOption, OptionsContextMenu } from "frontend/context-menu/optionsContextMenu";
import { PortalID } from "frontend/modal/portal-types";
import DownloadIcon from "frontend/icons/download";
import getTemplateDownloadsCount from "utils/template-utils";
interface TemplateCardTitleProps {
  templateName: string;
  downloadsCount?: number;
  mondaySolutionId?: string;
  showMenu: boolean;
  menuButtonRef: React.RefObject<HTMLDivElement>;
  backgroundClicked: () => void;
  options: ContextMenuOption[];
}

export default function TemplateCardTitle({
  templateName,
  mondaySolutionId,
  downloadsCount,
  showMenu,
  menuButtonRef,
  backgroundClicked,
  options,
}: TemplateCardTitleProps) {
  const name = templateName.charAt(0).toLocaleUpperCase() + templateName.slice(1);
  const templateDownloadsCount = getTemplateDownloadsCount(downloadsCount);

  return (
    <div className={style.titleContainer}>
      {mondaySolutionId && (
        <img src={getPathPrefix("/images/monday-mini-logo.svg")} className={style.mondayLogo} alt="monday-logo" />
      )}
      <div className={style.templateTitle}>{name}</div>
      {templateDownloadsCount ? (
        <div className={style.downloadsCountContainer}>
          <DownloadIcon size={10} />
          <span className={style.downloadsCount}>{templateDownloadsCount}</span>
        </div>
      ) : null}
      {showMenu && (
        <OptionsContextMenu
          options={options}
          attachToRef={menuButtonRef}
          onDismiss={backgroundClicked}
          portalID={PortalID.Modal}
        />
      )}
    </div>
  );
}
